import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)
app.use(router)

// No bulk match history is requested here. Routes and panels that need the
// 25k-match samples ask MatchesCache.ensureMatches() for the modes they use,
// so Matches, Player, Leaderboard and unknown routes render without it.

app.mount('#app')
